var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thinning-template',{attrs:{"thinning-skin":_vm.thinningSkin,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }